import React, { useState } from "react";
import ChatIcon from "../assets/images/icons/chat.svg";
import WhatsAppLogo from "../assets/images/icons/whatsapp-logo.svg";
import PhoneIcon from "../assets/images/icons/phone.svg";
import MailIcon from "../assets/images/icons/mail.svg";

const ChatOptionContainer = ({ bgColor, children, link }) => {
  return (
    <a target="_blank" rel="noreferrer noopener" href={link}>
      <div
        className={`${bgColor} cursor-pointer mb-6 flex w-12 h-12 items-center justify-center text-white translate-y-20 transition-all rounded-full`}>
        {children}
      </div>
    </a>
  );
};

const LiveChat = () => {
  const [showAll, setshowAll] = useState(false);

  const handleShowAll = () => {
    setshowAll((prev) => !prev);
  };

  return (
    <div
      onClick={handleShowAll}
      className="fixed z-20 bottom-28 mb-3 right-10 lg:right-14 flex flex-col-reverse">
      <div className="cursor-pointer flex w-12 h-12 items-center justify-center  bg-cstm-green text-white translate-y-20 transition-all rounded-full">
        <img src={ChatIcon} alt="chat button" />
      </div>

      {showAll && (
        <>
          <ChatOptionContainer link="https://wa.me/2349158428464?text=Hello%20Reeddi!">
            <img src={WhatsAppLogo} alt="whatsapp button" />
          </ChatOptionContainer>
          <ChatOptionContainer link="tel:+2349158428464" bgColor="bg-blue-500">
            <img src={PhoneIcon} alt="phone button" />
          </ChatOptionContainer>
          <ChatOptionContainer
            link="mailto:hello@reeddi.com"
            bgColor="bg-red-600">
            <img src={MailIcon} alt="chat button" />
          </ChatOptionContainer>
        </>
      )}
    </div>
  );
};

export default LiveChat;
